import { useSelector } from "react-redux";

let userPermission = [];
let userDetails = {};



// update user permission data by login user id
export function updateUserPermission(newValue) {
  userPermission = newValue;
}

// update user details by login userid
export function updateUserDetails(newValue) {
  userDetails = newValue;
}

// return only list of user permission data
export function getUserPermissionData() {
  return userPermission;
}

// return only user single data
export function getUserData() {
  return userDetails;
}

export function getUserPermissionComponent() {
  console.log("getUserPermissionComponent is calledddddd");
  function UserPermissionComponent() {
    const userPermission = useSelector((state) => state.userPermission);
    <span>{console.log("state", userPermission)}</span>

    updateUserPermission(userPermission);
    console.log("userPermission================================>>>>>>>", userPermission);
    updateUserDetails(userDetails);
    console.log("userDetails================================>>>>>>>", userDetails);

    return null;
  }
  return <UserPermissionComponent />;
}

// check user permission data based on permission
// export function checkUserPermission(permission) {
//   console.log("useSelector",useSelector);
//   let userPermission = getUserPermissionComponent();
//   console.log("userPermission", userPermission);
//   if (
//     userDetails &&
//     userDetails.RoleType &&
//     userDetails.RoleType.toUpperCase() === "SUPERADMIN"
//   ) {
//     return true;
//   } else {
//     if (
//       userPermission !== null &&
//       userPermission !== "" &&
//       !userPermission.some((item) => item.Name === permission)
//     ) {
//       return false;
//     } else {
//       // set permission status
//       return true;
//     }
//   }
// }


// check user permission data based on permission
export function checkUserPermission(permission) {
  let userPermission = getUserPermissionData();
  // console.log("userPermission", userPermission);
  if (userDetails && userDetails.RoleType && userDetails.RoleType.toUpperCase() === "SUPERADMIN") {
    return true;
  } else if (userPermission !== null && userPermission.some((item) => item.Name === permission)) {
    return true;
  } else {
    return false;
  }
}

